import { EntityProfileType } from "@common/types/entity";

export const ENTITY_TYPE_LABELS: Record<EntityProfileType, string> = {
    c_corp: "C Corp",
    s_corp: "S Corp",
    sole_proprietorship: "Sole Proprietorship",
    smllc: "LLC (single owner)",
    mmllc: "LLC (multiple owners)",
    partnership: "Partnership (including LLPs)",
    no_legal_entity: "I don't have a US legal entity",
};
